import { t } from 'ember-intl';
import Divider from 'tio-ui/components/divider';

<template>
  {{! Public Service Loan Forgiveness }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">
      {{t "pslf.questions.public_service.pslf_title"}}
    </h2>
    <p class="pt-4">{{t "pslf.questions.public_service.pslf_description"}}</p>
    <ul class="p-4 list-disc">
      <li>{{t "pslf.questions.public_service.do_not_refinance"}}</li>
    </ul>
  </div>

  {{! Am I Eligible? }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">{{t "pslf.questions.am_i_eligible"}}</h2>
    <div class="tio-col-flush pt-6 sm:grid sm:grid-cols-2">
      <div class="pr-3">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.borrower_eligibility.title"}}
        </h3>
        <p class="pt-4">
          {{t "pslf.questions.public_service.borrower_eligibility.description" htmlSafe=true}}
        </p>
        <h3 class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.which_repayment.title"}}
        </h3>
        <ul class="p-4 list-disc">
          <li>{{t "pslf.questions.public_service.which_repayment.item_1"}}</li>
          <li>{{t "pslf.questions.public_service.which_repayment.item_2"}}</li>
          <li>{{t "pslf.questions.public_service.which_repayment.item_3"}}</li>
          <li>{{t "pslf.questions.public_service.which_repayment.item_4"}}</li>
        </ul>
      </div>
      <div class="pt-4 sm:pl-3 sm:pt-0">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.loan_types.title"}}
        </h3>
        <ul class="p-4 list-disc">
          <li>{{t "pslf.questions.public_service.loan_types.item_1"}}</li>
          <li>
            {{t "pslf.questions.public_service.loan_types.item_2"}}
            <ul class="pl-4 list-disc">
              <li>{{t "pslf.questions.public_service.loan_types.item_2_note"}}</li>
            </ul>
          </li>
          <li>
            {{t "pslf.questions.public_service.loan_types.item_3"}}
            <ul class="pl-4 list-disc">
              <li>{{t "pslf.questions.public_service.loan_types.item_3_note"}}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  {{! Plan Details }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">{{t "pslf.questions.plan_details"}}</h2>
    <div class="tio-col-flush pt-6 pb-2 sm:grid sm:grid-cols-3">
      <div>
        <p class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.plan.forgiven_after.title"}}
        </p>
        <p>{{t "pslf.questions.public_service.plan.forgiven_after.description"}}</p>
      </div>
      <div class="sm:ml-5">
        <p class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.plan.max_forgiveness.title"}}
        </p>
        <p>{{t "pslf.questions.public_service.plan.max_forgiveness.description"}}</p>
      </div>
      <div>
        <p class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.plan.tax_info.title"}}
        </p>
        <p>{{t "pslf.questions.public_service.plan.tax_info.description"}}</p>
      </div>
    </div>
    <Divider class="my-2" />
    <div class="tio-col-flush sm:grid sm:grid-cols-2">
      <div class="p-3">
        <h3 class="tio-text-lg-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.plan.pros.title"}}
        </h3>
        <ul class="p-4 pt-0 list-disc">
          <li>{{t "pslf.questions.public_service.plan.pros.item_1"}}</li>
          <li>{{t "pslf.questions.public_service.plan.pros.item_2"}}</li>
        </ul>
      </div>
      <div class="p-3">
        <h3 class="tio-text-lg-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.plan.cons.title"}}
        </h3>
        <ul class="p-4 pt-0 list-disc">
          <li>{{t "pslf.questions.public_service.plan.cons.item_1"}}</li>
          <li>{{t "pslf.questions.public_service.plan.cons.item_2"}}</li>
        </ul>
      </div>
    </div>
  </div>

  {{! Next Steps }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">{{t "pslf.questions.next_steps"}}</h2>
    <div class="tio-col-flush pt-6 sm:grid sm:grid-cols-2">
      <div class="pr-3">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.make_the_switch.title"}}
        </h3>
        <ul class="p-4 list-disc">
          <li>{{t "pslf.questions.public_service.make_the_switch.item_1"}}</li>
          <li>{{t "pslf.questions.public_service.make_the_switch.item_2" htmlSafe=true}}</li>
          <li>{{t "pslf.questions.public_service.make_the_switch.item_3" htmlSafe=true}}</li>
          <li>{{t "pslf.questions.public_service.make_the_switch.item_4"}}</li>
        </ul>
        <h3 class="pt-6 font-semibold tio-fg-secondary">
          {{t "pslf.questions.need_more_help.title"}}
        </h3>
        <p class="pt-4">{{t "pslf.questions.need_more_help.description" htmlSafe=true}}</p>
      </div>
      <div class="pt-4 sm:pl-3 sm:pt-0">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.public_service.stay_on_track.title"}}
        </h3>
        <ul class="p-4 list-disc">
          <li>{{t "pslf.questions.public_service.stay_on_track.item_1" htmlSafe=true}}</li>
          <li>{{t "pslf.questions.public_service.stay_on_track.item_2" htmlSafe=true}}</li>
          <li>{{t "pslf.questions.public_service.stay_on_track.item_3"}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
